"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragSource = (function () {
  function DragSource() {
    _classCallCheck(this, DragSource);
  }

  DragSource.prototype.canDrag = function canDrag() {
    return true;
  };

  DragSource.prototype.isDragging = function isDragging(monitor, handle) {
    return handle === monitor.getSourceId();
  };

  DragSource.prototype.endDrag = function endDrag() {};

  return DragSource;
})();

exports["default"] = DragSource;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/dnd-core/lib/DragSource.js
 ** module id = 343
 ** module chunks = 0
 **/